import Http, { UrlFull } from "../Http";

export const saveInfo = (data) => Http.post(UrlFull + "api/docs/solicitud",{
        "doc_documento_solicitud": [data]
    }
)


